/**
 * License Acquisition.
 *
 *
 * @beta
 */
export const LICENSE_ACQUISITION = 'LicenseAcquisition'
